<ng-container [formGroup]="form">
  <label for="password" class="form-label"><sup>* </sup>Password</label>
  <input type="password"
         formControlName="password"
         class="form-control form-control-lg"
         id="password"
         placeholder="Your secure password"
         yp-e2e-id="input-password">

  <div class="alert-container" *ngIf="password?.dirty && password?.errors">
    <div class="alert alert-danger"
         yp-e2e-id="verify-password-validation-required"
         *ngIf="password.errors?.required">{{FIELD_MANDATORY_ERROR}}
    </div>
    <div *ngIf="!password.errors.required">
      <div class="alert alert-danger">
        Your password must have at least:
      </div>
      <div class="alert alert-danger"
           yp-e2e-id="create-password-length-error"
           [class.valid-password-pattern]="!password.errors.minlength">
        <i class="fal fa-check" *ngIf="!password.errors.minlength"></i> 8 characters
      </div>
      <div class="alert alert-danger"
           yp-e2e-id="create-password-uppercase-error"
           [class.valid-password-pattern]="hasUppercaseLetterInString">
        <i class="fal fa-check" *ngIf="hasUppercaseLetterInString"></i> 1 uppercase letter
      </div>
      <div class="alert alert-danger"
           yp-e2e-id="create-password-number-error"
           [class.valid-password-pattern]="hasNumberInString">
        <i class="fal fa-check" *ngIf="hasNumberInString"></i> 1 number
      </div>
    </div>
  </div>
</ng-container>

